import React from "react";
import {wordCheckEvent} from "utils/wordCheckUtils";

const PasswordInputBox = ({id, max, className, hint}) => {
  return (
    <input
      type="password"
      id={id}
      className={`fw-5 ${className}`}
      maxLength={max}
      placeholder={hint}
      autoComplete="off"
      onInput={(e) => wordCheckEvent(e, "password")}
    />
  );
}

export default PasswordInputBox;